import { Scale } from 'lucide-react';
import SEOHead from '@/components/SEOHead';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead
        title="Kullanım Koşulları | TesisKirala.com"
        description="TesisKirala.com Kullanım Koşulları ve Kullanıcı Sözleşmesi. Platformumuzu kullanırken uyulması gereken kurallar."
        canonicalPath="/kullanim-kosullari"
      />
      
      {/* Hero */}
      <section className="bg-emerald-800 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-emerald-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Scale className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Kullanım Koşulları
          </h1>
          <p className="text-emerald-100">
            Son güncelleme: Aralık 2024
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-slate max-w-none">
            
            <h2>1. Kabul ve Bağlayıcılık</h2>
            <p>
              TesisKirala.com web sitesini ("Site") kullanarak, bu Kullanım Koşulları'nı okuduğunuzu, 
              anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz. Bu koşulları kabul etmiyorsanız, 
              lütfen Siteyi kullanmayınız.
            </p>

            <h2>2. Hizmet Tanımı</h2>
            <p>
              TesisKirala.com, kullanıcıların spor tesislerini (halı saha, kapalı spor salonu vb.) 
              bulmasını, incelemesini ve online olarak rezervasyon yapmasını sağlayan bir platformdur.
            </p>

            <h2>3. Üyelik Koşulları</h2>
            <h3>3.1. Üyelik Şartları</h3>
            <ul>
              <li>18 yaşından büyük olmak</li>
              <li>Geçerli ve doğru bilgiler vermek</li>
              <li>Her kullanıcı yalnızca bir hesap açabilir</li>
            </ul>
            
            <h3>3.2. Hesap Güvenliği</h3>
            <p>
              Hesabınızın güvenliğinden siz sorumlusunuz. Şifrenizi güçlü tutun ve başkalarıyla paylaşmayın. 
              Hesabınızda şüpheli bir aktivite fark ederseniz derhal bize bildirin.
            </p>

            <h2>4. Rezervasyon Kuralları</h2>
            <h3>4.1. Rezervasyon Oluşturma</h3>
            <ul>
              <li>Rezervasyonlar, ödeme tamamlandıktan sonra kesinleşir</li>
              <li>Rezervasyon bilgilerinizin doğruluğundan siz sorumlusunuz</li>
              <li>Aynı saat için birden fazla rezervasyon yapılamaz</li>
            </ul>

            <h3>4.2. İptal Politikası</h3>
            <ul>
              <li>Rezervasyon başlangıcından 24 saat önceye kadar ücretsiz iptal</li>
              <li>24 saatten az kalan iptallerde ücret iadesi yapılmaz</li>
              <li>Tesis kaynaklı iptallerde tam iade yapılır</li>
            </ul>

            <h2>5. Kullanıcı Yükümlülükleri</h2>
            <p>Kullanıcılar aşağıdaki kurallara uymayı kabul eder:</p>
            <ul>
              <li>Tesis kurallarına uymak</li>
              <li>Diğer kullanıcılara saygılı davranmak</li>
              <li>Tesise zarar vermemek</li>
              <li>Yasalara aykırı faaliyetlerde bulunmamak</li>
              <li>Siteyi kötüye kullanmamak</li>
            </ul>

            <h2>6. Tesis Sahibi Yükümlülükleri</h2>
            <p>Tesis sahipleri aşağıdaki yükümlülükleri kabul eder:</p>
            <ul>
              <li>Tesis bilgilerini doğru ve güncel tutmak</li>
              <li>Uygun çalışma saatlerini belirtmek</li>
              <li>Hijyen ve güvenlik standartlarına uymak</li>
              <li>Onaylanan rezervasyonları kabul etmek</li>
            </ul>

            <h2>7. Ödeme Koşulları</h2>
            <ul>
              <li>Tüm fiyatlar TL cinsinden ve KDV dahildir</li>
              <li>Ödeme, güvenli ödeme altyapısı üzerinden yapılır</li>
              <li>Platform komisyonu rezervasyon bedelinden kesilir</li>
            </ul>

            <h2>8. Sorumluluk Sınırlaması</h2>
            <p>
              TesisKirala.com, tesis sahipleri ile kullanıcılar arasında bir aracı platformdur. 
              Tesislerin kalitesi, güvenliği veya uygunluğu konusunda garanti vermez. Tesis içinde 
              yaşanabilecek kaza veya hasarlardan sorumlu değildir.
            </p>

            <h2>9. Fikri Mülkiyet</h2>
            <p>
              Site üzerindeki tüm içerik, tasarım, logo ve yazılım TesisKirala.com'a aittir. 
              İzinsiz kopyalama, dağıtma veya değiştirme yasaktır.
            </p>

            <h2>10. Hesap Askıya Alma ve Fesih</h2>
            <p>
              Kullanım koşullarını ihlal eden hesaplar uyarı yapılmadan askıya alınabilir veya 
              kalıcı olarak silinebilir.
            </p>

            <h2>11. Uyuşmazlık Çözümü</h2>
            <p>
              Bu sözleşmeden doğan uyuşmazlıklarda İstanbul Mahkemeleri ve İcra Daireleri yetkilidir. 
              Türkiye Cumhuriyeti yasaları uygulanır.
            </p>

            <h2>12. İletişim</h2>
            <p>
              Kullanım koşulları hakkında sorularınız için:
            </p>
            <ul>
              <li><strong>E-posta:</strong> tesiskirala@gmail.com</li>
              <li><strong>Telefon:</strong> +90 505 368 60 91</li>
            </ul>

          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
